import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { RoleGuard } from './guards/role-guard';
import {PaymentSummaryComponent} from "./payment-summary/payment-summary.component";
import {LoginCheck} from "./guards/loginCheck";
import {TermsConditionsComponent} from "./terms-conditions/terms-conditions.component";

const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  // { path: 'individual', loadChildren: () => import('./individual/individual.module').then(m => m.IndividualModule) },
  {
    path: 'individual',
    loadChildren: () => import('./individual/individual.module').then(m => m.IndividualModule), canActivate: [RoleGuard],
    data: { restrictedRoles: ['IMPORT_CUSTOMER', 'IMPORT_ADMIN'] } // Specify roles that shouldn't access
  },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'institution', loadChildren: () => import('./manager/manager.module').then(m => m.ManagerModule) },
  { path: 'modal', loadChildren: () => import('./modals/modals.module').then(m => m.ModalsModule)},
  { path: 'payment', loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsModule) },
  { path: 'tracking', loadChildren: () => import('./tracking/tracking.module').then(m => m.TrackingModule) },
  { path: 'manager', loadChildren: () =>import('./manager/manager.module').then((m) => m.ManagerModule)},
  { path: 'import', loadChildren: () => import('./import-tool/import.module').then(m => m.ImportModule) },
  { path: 'payment-summary', component: PaymentSummaryComponent, canActivate: [LoginCheck] },
  { path: 'terms-and-conditions', component: TermsConditionsComponent },
  // { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules,scrollPositionRestoration:'enabled'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
